import { Link, useNavigate, useParams } from 'react-router-dom';
import backicon from '../../../assets/images/back.png';
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearMessage, setMessageStatus } from '../../../slices/messages';
import { createPost, singlePost } from '../../../slices/posts';
import { useTranslation } from 'react-i18next';

const CreatePost = () => {
    const { user} = useSelector((state) => state.auth);
    const { id } = useParams();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t} = useTranslation();

    const [form, setForm] = useState({});
    const [submitted, setSubmitted] = useState(0);
    const { message } = useSelector((state) => state.message);

    const { Status, post } = useSelector((state) => state.posts);

    const handleChange = (e) => {

        if (e.target.name == "image") {
            setForm({ ...form, [e.target.name]: e.target.files[0] });
        } else if (e.target.name == "no_of_days") {    
            setForm({ ...form, [e.target.name]: e.target.value.replace(/\D/g, "") });    
        } else {
            setForm({ ...form, [e.target.name]: e.target.value });
        }
    }
    useEffect(() => {
        if(user && user.approve == "N") {
            navigate('/profile');
        }
        dispatch(clearMessage());
        if (id) {
            dispatch(singlePost(id))
        }
    }, []);

    useEffect(() => {
        if (id) {
            setForm(post);
        }
    }, [post]);

    const handleSubmit = (e) => {
        e.preventDefault();
        var inputs = form;
        setSubmitted(1);
        dispatch(createPost(inputs))
            .unwrap()
            .then(() => {
                dispatch(setMessageStatus('Success'));
                navigate("/my-posts");
            })
            .catch((e) => {
                window.scrollTo(0, 0);
                setSubmitted(0);
            });
    }

    return (
        <div className="container">
            <section className="mt-5 pt-5">
                <div className="row">
                    <div className='col-md-12'>
                        <div className='card form-card bg-2'>
                            <div className='card-header mt-2-5 p-0'>
                                <Link to='/my-posts' className='back-link pl-2-5'>
                                    <img src={backicon} />
                                </Link>
                                <div className='section-title text-center' id='heading_title'>
                                    {
                                        id ?
                                            <h1 className='mb-0'><span className='font-color-1'>{t('editPost')}</span></h1>
                                            :
                                            <h1 className='mb-0'><span className='font-color-1'>{t('create_post')}</span></h1>
                                    }
                                </div>
                            </div>
                            <div className='card-body'>
                                {(message && Status == "Failed") && (
                                    <div className="col-md-12 error-section mt-2-5">
                                        <div
                                            className="alert alert-warning"
                                            role="alert"
                                        >
                                            {message}
                                        </div>
                                    </div>
                                )}
                                <form method="post" onSubmit={(e) => handleSubmit(e)}>
                                    <div className='row mt-2-5'>
                                        <div className="col-md-6 form-group mb-1-5">
                                            <label>{t('title')} ({t('in_hindi')})</label>
                                            <input type="text" className="form-control" placeholder={t('enter_title')} name='title_hi'  onChange={(e) => handleChange(e)} value={form?.title_hi ? form?.title_hi : ""} />
                                        </div>
                                        <div className="col-md-6 form-group mb-1-5">
                                            <label>{t('title')} ({t('in_english')})</label>
                                            <input type="text" className="form-control" placeholder={t('enter_title')} name='title_en' onChange={(e) => handleChange(e)} value={form?.title_en ? form?.title_en : ""} />
                                        </div>
                                        <div className="col-md-6 form-group mb-1-5">
                                            <label>{t('no_of_days')}</label>
                                            <input type="text" className="form-control" placeholder={t('enter_days')} name='no_of_days'  onChange={(e) => handleChange(e)} value={form?.no_of_days ? form?.no_of_days : ""} />
                                        </div>
                                        {
                                            id ?
                                                <div className="col-md-6 form-group mb-1-5">
                                                    <label>{t('image')} (565x400)</label>
                                                    <div className='editImage'>
                                                        <input type="file" className="form-control" placeholder="Enter image" name='image' required={id == ""} onChange={(e) => handleChange(e)} style={{ 'border': 'none', 'padding': 0 }} />
                                                        {
                                                            id &&
                                                            <img src={post?.image_path} width={100} height={70} />
                                                        }
                                                    </div>
                                                </div>
                                                :
                                                <div className="col-md-6 form-group mb-1-5">
                                                    <label>{t('image')} (565x400)</label>
                                                    <input type="file" className="form-control" placeholder="Enter image" name='image' required={id == ""} onChange={(e) => handleChange(e)} />
                                                </div>
                                        }
                                    </div>

                                    <div className='row'>
                                        <div className="col-md-12 form-group mb-1-5">
                                            <label>{t('description')} ({t('in_hindi')})</label>
                                            <textarea className='form-control' placeholder={t('enter_description')} rows={40} name="description_hi"  onChange={(e) => handleChange(e)} value={form?.description_hi ? form?.description_hi : ""} />
                                        </div>
                                        <div className="col-md-12 form-group mb-1-5">
                                            <label>{t('description')} ({t('in_english')})</label>
                                            <textarea className='form-control' name="description_en" placeholder={t('enter_description')} rows={40} onChange={(e) => handleChange(e)} value={form?.description_en ? form?.description_en : ""} />
                                        </div>
                                        <div className='col-md-6 m-auto'>
                                            {
                                                submitted ?
                                                    <button className='form-group mb-1-5 btn btn-primary btn-block'>{t('please_wait')}</button>
                                                    :
                                                    <button className='form-group mb-1-5 btn btn-primary btn-block'>{t('submit')}</button>
                                            }
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <div className='table-area bg-2 font-color'>

                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
export default CreatePost;